import MuiDialog from "@mui/material/Dialog";

export default function Dialog(props) {
  return <MuiDialog {...props} />;
}
